module.exports = __webpack_public_path__ + "assets/media/evening.0827440a.mp3";